<template>
  <span>
     <img :class="inputClass" :src="image_url" alt="" :style="inputStyle" onerror="this.src='/assets/img/default-male.svg'">
  </span>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    gender: {
      default: () => 'M'
    },
    type: {
      default: () => 'S'
    },
    inputClass: {
      type: String,
      default: () => ''
    },
    inputStyle: {
      type: String,
      default: () => ''
    },
    avatar_url: {
      type: String,
      default: () => null
    },
    is_self: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    }),
    image_url() {
      let img_url = '/assets/img/lecture-man.svg';
      if (!this.isEmpty(this.avatar_url)) {
        img_url = this.avatar_url;
      } else if (this.is_self && (!this.isEmpty(this.auth) && !this.isEmpty(this.auth.media) && !this.isEmpty(this.auth.media.images))) {
        img_url = this.auth.media.images.thumb.link;
      } else if (this.gender == 'M' && this.type == 'L') {
        img_url = '/assets/img/lecture-man.svg';
      } else if (this.gender == 'F' && this.type == 'L') {
        img_url = '/assets/img/lecture-woman.svg';
      } else if (this.gender == 'M' && this.type == 'S') {
        img_url = '/assets/img/default-male.svg';
      } else if (this.gender == 'F' && this.type == 'S') {
        img_url = '/assets/img/default-female.png';
      }

      return img_url;
    }
  }
}
</script>
